export default {
  beige: '#DBC087',
  darkBeige: '#AB8D60',

  black: '#333333',
  gray: '#999',
}
